/**
 * 同时发布的栏目标题图
 */
import React, {Component} from 'react';
import {Icon, Radio} from "antd";
import UploadWall from "../../../components/upload/UploadWall";
import ImgChoose from "../components/editContentChoose/ImgChoose";
import VideoCapture from "../components/editContentChoose/VideoCapture";
import {message} from "../../sysManagement/utils/sysManagementUtils";
import {unitConvert} from "../../../utils";
import $Jq from "jquery";
import {DetailDialog as Picture} from "../../resource/view/dialog/picture/picture";
import SelectImg from "../../../containers/mmp/article/selectImg";
import BaseComponent from "../../../base/BaseComponent";

export default class MeanwhilePublishTitlePic extends BaseComponent {
    static propTypes = {};
    static defaultProps = {
        showSelectOperate: true,
        showCutOperate: true,
        selectByLocal: false
    };

    constructor(props) {
        super(props);
        this.state = {
            newPicType: ['jpg', 'jpeg', 'gif', 'png', 'bmp'],
            titlePicList: this.getTitlePicList(),
            titlePicShowType: "oneSmall",
            imgAll: [],//内容全部图片
            videoAll: [],//内容全部视频
            imgList: [], //图集图片
        }
    }

    componentWillMount() {
        if(this.props.currentItem && this.props.currentItem.titlePicList && this.props.currentItem.titlePicShowType) {
            this.setPicData(this.props.currentItem);
        }
    }

    componentDidMount() {
    }

    getPicData() {
        let titlePicList = [];
        let titlePicShowType = this.state.titlePicShowType;
        this.state.titlePicList[titlePicShowType].forEach(item => {
            if (item.titlePic) {
                titlePicList.push(item.titlePic);
            }
        })
        if (titlePicShowType === "threeSmall" && titlePicList.length && titlePicList.length < 3) {
            message.warn("请上传三张图！");
            return false;
        }
        return {
            titlePicList,
            titlePicShowType
        };
    }

    setPicData(currentItem) {
        let {titlePicList = [], titlePicShowType = "oneSmall"} = currentItem;
        titlePicList.length && titlePicList.forEach((item, index) => {
            this.state.titlePicList[titlePicShowType][index].titlePic = item;
        })
        this.setState({
            titlePicShowType
        })
    }

    getTitlePicList() {
        return {
            "oneSmall": [{
                type: "oneSmall",
                titlePic: "",
                loading: false,
                hover: false,
                top: 40
            }],
            "oneBig": [{
                type: "oneBig",
                titlePic: "",
                loading: false,
                hover: false,
                top: 40
            }],
            "threeSmall": [{
                type: "threeSmall1",
                titlePic: "",
                loading: false,
                hover: false,
                top: 40
            }, {
                type: "threeSmall2",
                titlePic: "",
                loading: false,
                hover: false,
                top: 185
            }, {
                type: "threeSmall3",
                titlePic: "",
                loading: false,
                hover: false,
                top: 330
            }],
        }
    }

    renderTitlePicUpload(item, index) {
        let {imgAll, videoAll, imgList} = this.state;
        console.log(videoAll)
        return (
            <div className="upload-wrap" key={item.type} style={{marginBottom: index < 2 ? 15 : 0}}>
                <div onMouseEnter={() => this.handleEnter(item)}>
                    <UploadWall
                        accept={"." + this.state.newPicType.join(",.")}
                        uploadBtnName={this.props.isPcIcon}
                        name="file"
                        action="/dynamic/storage/uploadFile"
                        onChange={(info) => {
                            this.handleChange(info, item);
                        }}
                        beforeUpload={this.handleBeforeUpload}
                        style={{
                            width: "130px",
                            height: "130px",
                            overflow: "hidden",
                            padding: "0",
                            position: 'relative'
                        }}
                        imageUrl={item.titlePic}
                    />
                </div>
                <div className={"upload-tip"}>
                    <div>
                        {this.props.showSelectOperate ?
                            <div onClick={() => {
                                this.currentClickIndex = index;
                                if(this.props.selectByLocal && typeof this.props.selectByLocalFunction === "function") {
                                    this.SelectImg.showModal();
                                    this.props.selectByLocalFunction((imgList) => {
                                        this.setState({
                                            imgList
                                        })
                                    });
                                }else {
                                    this.imgChoose.showModal();
                                    this.contentChoose();
                                }
                            }} style={{
                                alignSelf: "flex-end",
                                color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"),
                                fontSize: "12px",
                                cursor: "pointer",
                                lineHeight: '12px',
                                marginBottom: '15px'
                            }}>正文选择
                            </div> : null}
                        {this.props.showCutOperate ?
                            <div onClick={() => {
                                this.currentClickIndex = index;
                                if(this.props.selectByLocal && typeof this.props.selectByLocalFunction === "function") {
                                    this.props.selectByLocalFunction((videoAll) => {
                                        this.setState({
                                            videoAll
                                        },() => {
                                            this.videoCapture.showModal();
                                        })
                                    });
                                }else {
                                    this.videoCaptureContent();
                                }
                            }} style={{
                                alignSelf: "flex-end",
                                color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"),
                                fontSize: "12px",
                                cursor: "pointer",
                                lineHeight: '12px',
                                marginBottom: '15px'
                            }}>视频截取
                            </div> : null}
                    </div>
                    {/*悬浮按钮*/}
                    {item.hover ? this.renderBtn(item) : null}
                    <span onClick={() => {
                        this.state.titlePicList[this.state.titlePicShowType][index].titlePic = "";
                        this.setState({});
                    }} style={{
                        alignSelf: "flex-end",
                        color: "#0050B3",
                        fontSize: "12px",
                        cursor: "pointer",
                        lineHeight: '12px',
                        marginBottom: '8px'
                    }}>删除</span>
                    <div className="tip-text">
                        支持bmp、jpg、png等常见图片格式文件上传，图片最大限制不超过20M
                    </div>
                </div>
                {/*预览*/}
                <Picture ref={ref => this.detailDialog = ref} path={this.previewPic}/>
                {/*正文选择*/}
                <ImgChoose getImgChoose={(data) => this.getImgChoose(data)} imgAll={imgAll}
                           ref={e => this.imgChoose = e}/>
                {/*选择图片*/}
                <SelectImg getImgChoose={(data) => this.getImgChoose(data)} imgAll={imgList}
                           ref={e => this.SelectImg = e}/>
                {/*视频截取*/}
                <VideoCapture getVideoPicture={(data) => this.getVideoPicture(data, item)} videoAll={videoAll}
                              ref={e => this.videoCapture = e}/>
            </div>
        )
    }

    //鼠标悬浮图片按钮
    renderBtn = (item) => {
        return (
            <div style={{
                display: 'block'
            }} onMouseLeave={() => this.handleOut(item)}>
                <div style={{
                    width: 130,
                    height: 130,
                    background: 'rgba(0,0,0,0.4)',
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    position: 'absolute',
                    top: item.top,
                    left: 0,
                }}>
                    <Icon type={'eye'} style={{width: 20, height: 20, color: "#fff", cursor: 'pointer'}}
                          onClick={() => {
                              this.previewPic = item.titlePic;
                              this.setState({})
                              this.handlePreview();
                          }}
                    />
                    <Icon type={'delete'} style={{width: 20, height: 20, color: "#fff", cursor: 'pointer'}}
                          onClick={() => this.handleDelete(item)}
                    />
                    <Icon type={'edit'} style={{width: 20, height: 20, color: "#fff", cursor: 'pointer'}}
                          onClick={() => {
                              let imgName = "";
                              this.handleEdit(item, imgName)
                          }}
                    />
                </div>
            </div>
        )
    };

    previewPic = "";

    // 预览
    handlePreview = async file => {
        this.detailDialog.show();
    };

    //鼠标移出
    handleOut = (item) => {
        item.hover = false;
        this.setState({})
    };

    // 删除按钮
    handleDelete = (item) => {
        item.hover = false;
        item.titlePic = "";
        this.setState({})
    };

    //鼠标移入
    handleEnter = (item) => {
        if (!item.titlePic) return;
        item.hover = true;
        this.setState({})
    };

    // 编辑
    handleEdit = (item, name) => {
        let that = this;
        window.edit.callback = function (obj) {
            item.titlePic = obj.path;
            that.setState({})
        };
        window.edit.openEditPictureFrame(item.titlePic, name);
    };

    // 传标题图
    getImgChoose = (data) => {
        if (data) {
            this.state.titlePicList[this.state.titlePicShowType][this.currentClickIndex].titlePic = data;
            this.setState({})
        }
    }

    //传视频帧
    getVideoPicture = (data) => {
        if (data) {
            this.state.titlePicList[this.state.titlePicShowType][this.currentClickIndex].titlePic = data;
            this.setState({})
        }
    };

    handleChange(info, item) {
        if (info.file.status === "uploading") {
            item.loading = true;
            this.setState({});
            return;
        }
        if (info.file.status === "done") {
            if (info.file.response && info.file.response.status) {
                if (info.file.response.status == 200) {
                    item.titlePic = info.file.response.data.path;
                    item.loading = false;
                    this.setState({});
                } else {
                    message.error(info.file.response.message);
                }
            }
        }
    };

    //正文选择
    contentChoose() {
        let currentContent = window.ueditor.getContent();
        let imgAll = $Jq(currentContent).find('img').not("[alias-label='video']").not(".edui-upload-video").not(".edui-faked-video").not(".edui-faked-music");
        if (!(imgAll && imgAll.length)) return message.error("正文中未找到图片！");
        this.setState({imgAll});
    }

    //视频截取
    videoCaptureContent() {
        message.destroy();
        let currentVideo = document.getElementsByName("ueditor_subcontent")[0].contentWindow.document;
        let videoList = $Jq(currentVideo).find("[alias-label='video']");
        if (!(videoList && videoList.length)) {
            return message.error("正文中未找到视频！")
        }
        let videoAll = [];
        for (let j = 0; j < videoList.length; ++j) {
            if ($Jq(videoList[j]).attr("duration") > 0 && !this.isOutLink($Jq(videoList[j]).attr("source-url"))) {
                videoAll.push({
                    duration: $Jq(videoList[j]).attr("duration"),
                    src: $Jq(videoList[j]).attr("video-src"),// 视频内容
                    videoSrc: $Jq(videoList[j]).attr("video-pic"),//视频封面
                    videoWidth: $Jq(videoList[j]).width(),//视频封面
                    videoHeight: $Jq(videoList[j]).height(),//视频封面
                })
            }
        }
        if (!videoAll?.length) {
            return message.warn("网络视频无法视频截取！")
        }
        this.setState({videoAll}, () => {
            this.videoCapture.showModal();
        });
    }

    isOutLink = (url) => {
        if (url) {
            let reg = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
            return reg.test(url)
        }
        return false
    }

    //上传前添加上传提示，限制非格式的上传
    handleBeforeUpload = (file) => {
        let fileName = file.name.split('.');
        let upload = fileName.at(-1).toLowerCase();
        upload = this.state.newPicType.includes(upload);
        if (!upload) {
            message.error('暂不支持该文件类型!');
        }
        // 限制图片大小
        let picSize = unitConvert(file.size);
        if (file && file.size) {
            if (picSize.indexOf('MB') > -1) {
                let size = picSize.slice(0, -2);
                if (size > 20) {
                    message.error('图片最大限制不超过20M！');
                    return false;
                }
            }
            unitConvert(file.size);
        }
        return new Promise((resolve, reject) => {
            if (!upload) {
                reject(file);
            } else {
                resolve(file);
            }
        });
    };

    renderTypeSelect() {
        return (
            <div style={{display: "flex", alignItems: "center"}}>
                <div>显示类型：</div>
                <Radio.Group style={{lineHeight: "37px"}}
                             value={this.state.titlePicShowType}
                             onChange={(e) => {
                                 this.state.titlePicShowType = e.target.value;
                                 this.setState({});
                                 this.revertPic();
                             }}>
                    <Radio style={{marginRight: 5}} key={"small"} value={"oneSmall"}>一小图</Radio>
                    <Radio style={{marginRight: 5}} key={"big"} value={"oneBig"}>一大图</Radio>
                    <Radio key={"three_small"} value={"threeSmall"}>三小图</Radio>
                </Radio.Group>
            </div>
        )
    }

    revertPic() {
        this.state.titlePicList[this.state.titlePicShowType].forEach(item => {
            item.titlePic = "";
        })
        this.setState({});
    }

    render() {
        return (
            <>
                {this.renderTypeSelect()}
                {this.state.titlePicList[this.state.titlePicShowType].map((item, index) => {
                    return this.renderTitlePicUpload(item, index)
                })}
            </>

        )
    }
}